const directives = {
    track: {
        bind(el, binding, vnode) {
            if (vnode.componentInstance) {
                vnode.componentInstance.$on('click', () => {
                    window._hmt.push(['_trackEvent', binding.value, 'click']);
                });
            } else {
                el.addEventListener('click', () => {
                    window._hmt.push(['_trackEvent', binding.value, 'click']);
                });
            }
        }
    }
};

const install = function(Vue) {
    for (let key of Object.keys(directives)) {
        Vue.directive(key, directives[key]);
    }
};

export default install;
